<template>
	<v-app-bar
		app
		color="white"
		height="45"
		class="navbar"
		fixed
		flat
	>
		<router-link :to="{ name: 'home' }">
			<v-img
				width="100"
				src="@/assets/logo-text.png"
			/>
		</router-link>

		<v-spacer/>
		<div style="max-width: 60%">
			<v-tabs
				v-model="tab"
				show-arrows
				color="primary"
				center-active
				hide-slider
			>
				<!-- <v-tab
					:ripple="false"
					exact
					disabled
					class="px-1"
				>الطلاب</v-tab>
				
				<v-tab
					:ripple="false"
					exact
					disabled
					class="px-1"
				>المدرسين</v-tab> -->
				
				<v-tab
					v-if="!questionBankExamAndOnly"
					:ripple="false"
					exact
					class="px-1"
					:to="{ name: 'marks' }"
				>العلامات</v-tab>
				
				<v-tab
					:ripple="false"
					exact
					class="px-1"
					:to="{ name: 'questions-bank' }"
				>بنك الأسئلة</v-tab>
				
				<v-tab
					:ripple="false"
					exact
					class="px-1"
					:to="{ name: 'exams' }"
				>الاختبارات</v-tab>
				
				<v-tab
					:ripple="false"
					exact
					class="px-1"
					disabled
				>الجلاءات</v-tab>
			</v-tabs>
		</div>
		<v-spacer/>

		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					depressed
					color="transparent"
					class="px-2"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon>mdi-account-circle</v-icon>
					<span class="px-2">{{'مدرس'}}</span>
					<v-icon>mdi-chevron-down</v-icon>
				</v-btn>
			</template>

			<v-list dense>
				<v-list-item>
					<v-list-item-title>test</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
import { questionBankExamAndOnly } from '@/configs/general.configs';
export default {
	data() {
		return {
			questionBankExamAndOnly,

			tab: null,
		}
	},

	created() {
		switch (this.$route.name) {
		case 'home': 
		case 'classes': 
		case 'marks-scales': 
		case 'marks': 
		case 'student-marks': 
		case 'update-student-marks': this.tab = '/classes/marks'; break;
		case 'questions-bank':
		case 'question': this.tab = '/questions-bank'; break;
		case 'exams':
		case 'exam':
		case 'exam-preview': this.tab = '/exams'; break;
		}
	}
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';
.navbar {
	outline: 1px solid #00000023;

	@media #{map-get($display-breakpoints, 'lg-and-up')} {
		padding: 0 80px;
	}
}
</style>